
<template>
  <main style="background-color: white;">
    <div class="col-12 col-sm-5  col-md-5 container-sm  pdv-0">
      <div class="min-height-50" style=" background-color:#312972;" >
        <span class=""> <img src="@/assets/img/logo-pacifica/Logo.svg" /></span>
      </div>
      <div class="" style="background-color: #f6f7f8; border-radius: 0;">
        <div class="box-language">
          <div class="row gx-4">
            <div  class="mx-auto mt-3 col-lg-6 col-md-8 my-sm-auto ms-sm-auto me-sm-0" >
              <div class="nav-wrapper position-relative end-0">
                  <div class="row">
                    <div class="col d-flex justify-content-end">
                      <div class="col-auto d-flex align-items-center me-3">
                      </div>  
                        <InputRadio
                          v-model="languageStore.selectedLanguage"
                         name="languageSelect"
                         id="language1"
                         value="TH" /> 
                        <span class="ms-1">TH</span>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <InputRadio 
                           v-model="languageStore.selectedLanguage"
                          name="languageSelect"
                          id="language2"
                          value="EN" /> 
                          <span class="ms-1">EN</span>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class="col-12 col-sm-5 col-md-5 container-sm  pdv-0">
    <component :is="currentStep" 
      @next="goToEmailStep"
      @prev="goToReceiptStep" 
      @sendotp="goToOtpStep"
      @invoice="goToInvoiceStep"
      @preview="goToInvoicePreviewStep" 
      @submission="goToInvoiceSubmission"
      
     />
    
  </div>
  
  </main>
</template>
<style>
    .text-black{
    color : black!important;

  }

  .box-language{
    padding: 0.4rem 0.4rem;
  }

  .pdv-0{
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  main {
  /* width: 40vw;  */
  margin: 0 auto; 
}
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
* {
  --bs-gutter-x: 0 !important;
}

  
</style>




<script setup>
import { onMounted ,shallowRef } from "vue";
import { useStore } from "vuex";
import InputRadio from "@/components/global/InputRadio.vue";

import FormReceipt from '@/views/components/etax/page-form/FormReceipt.vue'

import FormSendEmail from "@/views/components/etax/page-form/FormSendEmail.vue";
 import FormSendOtp from '@/views/components/etax/page-form/FormSendOtp.vue';
 import FormInvoice from '@/views/components/etax/page-form/FormInvoice.vue';
 import FormInvoicePreview from '@/views/components/etax/page-form/FormInvoicePreview.vue';
 import FormInvoiceSubmission from '@/views/components/etax/page-form/FormInvoiceSubmission.vue';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();


//const currentStep = ref(FormReceipt);
const currentStep = shallowRef(FormReceipt);

const goToEmailStep = () => {
  currentStep.value = FormSendEmail;
};

const goToOtpStep = () => {
  currentStep.value = FormSendOtp;
};

const goToReceiptStep = () => {
  currentStep.value = FormReceipt;
};

const goToInvoiceStep = () => {
  currentStep.value = FormInvoice;
};

const goToInvoicePreviewStep = () => {
  currentStep.value = FormInvoicePreview;
};

const goToInvoiceSubmission = () => {
  currentStep.value = FormInvoiceSubmission;
};




const store = useStore();



onMounted(() => {
  store.state.isAbsolute = true;

});

//language
</script>
